import { IFilterStateAction } from '../actions/filter-actions';
import { ActionType, ActionTypes } from '../../actions/index';
import { IFetchStateAction } from '../actions/filter-fetch';
import { ISeatMatchRequestModel } from '../../classes/request-model';
import * as redux from 'redux';
import { SeatInfo } from '../../classes/seat';

export interface ISeatMatchResultModel {
    requesting: boolean;
    loadedResults: boolean;
    matchFilter: ISeatMatchRequestModel;
    numberOfTicketOptions: number;
    numberOfTicketsAvailable: number;
    onlyADASeats: boolean;
    suggestedSeats: Array<SeatInfo>;
    ticketMessaging: string;
    quickCheckoutMessage: string;
    dataHasLoaded: boolean;
}

let defaultSeatMatchResultModel: ISeatMatchResultModel = {
    quickCheckoutMessage: '',
    numberOfTicketOptions: 0,
    numberOfTicketsAvailable: 0,
    onlyADASeats: false,
    suggestedSeats: [],
    ticketMessaging: "",
    matchFilter: null,
    requesting: false,
    loadedResults: false,
    dataHasLoaded: false
};

export { defaultSeatMatchResultModel };

export function seatMatchResultModel(state: ISeatMatchResultModel = defaultSeatMatchResultModel, action: IFetchStateAction): ISeatMatchResultModel {
    switch (action.type) {
        case ActionTypes.REQUEST_SEATS:
            return {
                ...state,
                matchFilter: action.value, requesting: true, loadedResults: false
            };
        case ActionTypes.RECEIVE_SEATS:
            return {
                ...state,
                requesting: false,
                loadedResults: true,
                numberOfTicketOptions: action.value,
                ticketMessaging: 'test messaging',
                dataHasLoaded: true
            };
        case ActionTypes.SET_MATCHED_COUNT:
            return {
                ...state,
                numberOfTicketsAvailable: action.value.count,
                onlyADASeats: action.value.onlyADASeats,
                suggestedSeats: action.value.suggestedSeats
            };
        case ActionTypes.RECEIVE_QUICK_CHECKOUT_RESULT:
            return { ...state, quickCheckoutMessage: action.value.message };
        case ActionTypes.GO_TO_FILTERS:
            return { ...state, quickCheckoutMessage: '' };
        default:
            return state;
    }
};

const filterFetch = redux.combineReducers({
    seatMatchResultModel
})

export default filterFetch